export default __webpack_public_path__ + "static/media/login-banner.8c20f430.png";